export default "__VITE_PUBLIC_ASSET__56cf8ddc__"